import React from 'react';

export const Filter_1: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="2 2 20 20" {...props}>
    <g transform="translate(-1543 -280)">
      <rect
        width="16"
        height="1"
        rx=".5"
        transform="translate(1547 286)"
        fill="currentColor"
      />
      <rect
        width="16"
        height="1"
        rx=".5"
        transform="translate(1547 297)"
        fill="currentColor"
      />
      <path
        fill="#FFF"
        d="M1558 289a2.503 2.503 0 01-2.5-2.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z"
      />
      <path
        d="M1558 284.5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 110 6 3 3 0 010-6z"
        fill="currentColor"
      />
      <path
        fill="#FFF"
        d="M1553 300a2.503 2.503 0 01-2.5-2.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z"
      />
      <path
        d="M1553 295.5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 110 6 3 3 0 010-6z"
        fill="currentColor"
      />
    </g>
  </svg>
);
